import { render } from "./PageList.vue?vue&type=template&id=5b4fc8aa&scoped=true"
import script from "./PageList.vue?vue&type=script&lang=js"
export * from "./PageList.vue?vue&type=script&lang=js"

import "./PageList.vue?vue&type=style&index=0&id=5b4fc8aa&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b4fc8aa"]])

export default __exports__